import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Analytics, Statistics } from '@shared/analytics/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsApiService {
  private baseUrl = '/v.1/analytics';

  constructor(
    private readonly http: ApiClientService,
  ) { }

  load(): Observable<Analytics> {
    return this.http.get<Analytics>(this.baseUrl);
  }

  loadTodayStats(): Observable<Statistics> {
    return this.http.get<Statistics>(`${this.baseUrl}/today-stats`);
  }
}
